"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const o=require("@mui/material"),e=require("@mui/material/styles"),n=require("../../../appointment-details/appointment-details.types.js"),r=t=>({[n.AppointmentState.CANCELED]:t.palette.error[600],[n.AppointmentState.TREATED]:t.palette.secondary[600],[n.AppointmentState.IN_TREATMENT]:t.palette.highlight1[600],[n.AppointmentState.IN_TREATMENT_ROOM]:t.palette.primary[800],[n.AppointmentState.WAITING]:t.palette.warning[700]}),l=(t,i)=>{const a=r(t);if(Object.keys(a).includes(i))return a[i]},s=e.styled(o.CircularProgress)(({theme:t})=>({color:t.palette.primary[800],width:"24.56px",height:"32px",position:"absolute"})),p=e.styled("div",{shouldForwardProp:t=>t!=="grey"})`
  width: fill-available;
  display: flex;
  align-items: center;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  vertical-align: center;

  height: 42px;

  ${({grey:t})=>t&&e.css`
      color: rgba(0, 0, 0, 0.26);
    `};
`,d=e.styled("div")`
  display: flex;
  align-self: center;
  column-gap: ${({theme:t})=>t.spacing(1)};
`,c=e.styled(o.Typography,{shouldForwardProp:t=>t!=="grey"})`
  color: #424242;
  align-items: center;

  ${({grey:t})=>t&&e.css`
      opacity: 0.2;
    `};
`,g=e.styled(o.FormControlLabel)`
  display: flex;
  align-items: center;
  flex-direction: row;
  margin-right: ${({theme:t})=>t.spacing(2)};
`,u=e.styled("div")``,y=e.styled("div")`
  display: flex;
  height: inherit;
`,x=e.styled("div",{shouldForwardProp:t=>t!=="state"})(({theme:t,state:i})=>({display:"flex",marginRight:t.spacing(1),"&&&&":{color:l(t,i)},"&& .MuiSvgIcon-root":{fill:"none"}})),f=e.styled(o.Radio,{shouldForwardProp:t=>t!=="grey"})(({theme:t,grey:i})=>({...i&&{opacity:.2},"&&&.Mui-checked":{color:t.palette.primary[800]}})),C=e.styled(o.TextField)(({theme:t})=>({padding:0,[`& .${o.outlinedInputClasses.root}`]:{borderRadius:"2px",borderColor:t.palette.grey[600],color:t.palette.grey[800],minHeight:t.spacing(2),[`&.${o.inputClasses.focused} .${o.outlinedInputClasses.notchedOutline}`]:{borderColor:t.palette.primary[800]}},"& input":{fontFamily:"'Lato'",fontWeight:700,fontSize:"10px",lineHeight:"16px",letterSpacing:"0.5px",padding:t.spacing(0,.5),width:"44px",height:"24px",textAlign:"center"},"& fieldset":{padding:0}}));exports.Group=u;exports.IconContainer=x;exports.InputGroup=d;exports.LabelContainer=y;exports.LoadingCircle=s;exports.RadioButton=f;exports.RootContainer=p;exports.StatusLabel=c;exports.StatusText=g;exports.StyledTextField=C;
